export const GET_USER_INFO_DATA = 'User/get_user_info_data'
export const SET_USER_INFO_DATA = 'User/set_user_info_data'
export const SET_USER_INFO_MSG_DATA = 'User/set_user_info_msd_data'
export  const SET_HISTORY_DATA = 'User/set_history_data'
export  const GET_HISTORY_DATA = 'User/get_history_data'
